import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const deleteSchoolAvatar = async (schoolId, accessToken) => {
  try {
    const response = await fetch(
      BACKEND_URL + "/api/v1/schools/" + schoolId + "/avatar",
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de suppression de l'avatar!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const GetOneSchool = async (schoolId) => {
  try {
    const response = await fetch(
      BACKEND_URL + `/api/v1/schools/${schoolId}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error("Erreur de récupération de l'école!");
    }
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
};


const GetOne = async (schoolId) => {
  return useQuery(["school", schoolId], async () => {
    if (!schoolId) {
      return null;
    }
    try {
      const response = await fetch(
        BACKEND_URL +
        `/api/v1/schools/${schoolId}`,
        {
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Erreur de récupération de l'école!");
      }
      if (response.status >= 299) {
        throw new Error("Erreur de récupération de l'école!");
      }
      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }
  );
};

const UpdateOne = async (schoolId, accessToken, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification du créneau!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateLogo = async (schoolId, accessToken, newLogo) => {
  try {
    let formData = new FormData();
    formData.append("file", newLogo);
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/logo",
      {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification du logo de l'école!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteLogo = async (schoolId, accessToken) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/logo",
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de suppression du logo de l'école!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateAvatar = async (schoolId, accessToken, newAvatar) => {
  try {
    let formData = new FormData();
    formData.append("file", newAvatar);
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/avatar",
      {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification de l'image de l'école!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteAvatar = async (schoolId, accessToken) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/avatar",
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de suppression de l'image de l'école!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateSchoolPolicies = async (schoolId, accessToken, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/policies",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification des permissions!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
}

const GetMails = (
  schoolId,
  accessToken,
  page = 1,
  pageSize = 50,
  email = "",
  subject = "",
  status = ""
) => {
  return useQuery(
    ["school-mails", schoolId, accessToken, page, pageSize, email, subject, status],
    async () => {
      try {
        const response = await fetch(
          BACKEND_URL + `/api/v1/schools/${schoolId}/mails?page=${page}&pageSize=${pageSize}&email=${encodeURIComponent(email || "")}&subject=${encodeURIComponent(subject || "")}&status=${encodeURIComponent(status || "")}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok || response.status >= 299) {
          throw new Error("Erreur de récupération de la liste des emails de l'école!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error fetching school mails:", error);
        throw error;
      }
    }
  );
};

const schoolsAPI = {
  GetOne,
  GetOneSchool,
  UpdateOne,
  UpdateLogo,
  DeleteLogo,
  UpdateAvatar,
  DeleteAvatar,
  UpdateSchoolPolicies,
  GetMails,
};

export default schoolsAPI;
